import { IYieldCompounding } from '~/@api/generated-api-types-project/Api'
import { Text } from '~/@mid_ui/typography/Text'
import { ProjectYieldText } from '~/@pages_investing/projects/_projects_ui/project-yield-text/ProjectYieldText'
import { getProjectInvestmentPeriodString } from '~/@pages_investing/_utils/investmentPeriod.utils'
import { ProjectLabel } from '~/@pages_investing/projects/_projects_ui/project-popup-components/ProjectLabel'
import type { ProjectSchema } from '~/@pages_investing/projects/_project_types/project.types'
import { getProjectCollateralSubcategoryLabel } from '~/@pages_investing/projects/_projects_ui/project-collateral/labelByCollateralSubcategory'
import { DetailHeading } from '../project-detail_ui/detail-heading/DetailHeading'
import { BackButton } from '../project-detail_ui/back-button/BackButton'
import { HeadingOne } from '~/@mid_ui/typography/HeadingOne'
import { transformSecurity } from '~/@lib/utils/riskScoreMapper'

type Props = { project: ProjectSchema }

function FinishedProjectV2Overview({ project }: Props) {
  return (
    <div className="w-full">
      <div
        className={
          'flex flex-col lg:flex-row w-full border-b border-border-strong h-auto'
        }>
        <div className="flex flex-col items-start flex-1 gap-10 p-5 pb-15 md:px-10">
          <BackButton>Späť</BackButton>
          <div className="flex flex-col gap-2">
            <Text className="font-semibold">
              Investičná príležitosť ID: {project.businessId}
            </Text>
            <HeadingOne className="text-3xl">Detail investície</HeadingOne>
            <ProjectLabel
              category={project.collateralInfo.collateralCategory}
              subcategory={project.collateralInfo.collateralSubcategory}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-col lg:flex-row [&>div]:flex-1 [&>div]:border-r [&>div]:border-b [&>div]:border-[#969696] [&>div]:h-auto [&>div]:lg:h-[120px] [&>div]:p-5 [&>div]:lg:p-3 [&>div]:lg:px-6 [&>div]:lg:pb-4 [&>div]:flex [&>div]:flex-row [&>div]:lg:flex-col [&>div]:justify-between">
        {[
          {
            title: 'Doba úročenia',
            content: (
              <Text className="flex items-center uppercase text-primary self-end text-2xl font-semibold">
                {getProjectInvestmentPeriodString(
                  project.investmentPeriod,
                  project.yieldCompounding
                )}{' '}
                mesiacov
              </Text>
            ),
          },
          {
            title: 'Úrok ako predpokladaný výnos',
            content: (
              <Text className="flex items-center uppercase text-primary self-end text-2xl font-semibold">
                <ProjectYieldText
                  _calculatedValues={project._calculatedValues}
                  isYieldCompoundingAnnually={
                    project.yieldCompounding === IYieldCompounding.Annually
                  }
                  yieldIconSize={36}
                  yieldIconArrowColor="#000"
                />
              </Text>
            ),
          },
          {
            title: 'ltl:',
            content: (
              <Text className="flex items-center uppercase text-primary self-end text-2xl font-semibold">
                {project.collateralInfo?.ltlPercentage
                  ? `${project.collateralInfo.ltlPercentage}%`
                  : 'N/A'}
              </Text>
            ),
          },
          {
            title: 'riziko:',
            content: (
              <Text className="flex items-center uppercase text-primary self-end text-2xl font-semibold">
                {project.riskScore
                  ? transformSecurity(project.riskScore)
                  : 'N/A'}
              </Text>
            ),
          },
          {
            title: 'typ zaistenia:',
            content: (
              <Text className="flex items-center text-primary self-end text-2xl font-semibold">
                {getProjectCollateralSubcategoryLabel(
                  project.collateralInfo.collateralSubcategory
                )}
              </Text>
            ),
          },
        ].map(({ title, content }) => (
          <div key={title} className="flex flex-col">
            <DetailHeading title={title} />
            {content}
          </div>
        ))}
      </div>
    </div>
  )
}

export { FinishedProjectV2Overview }
